'use strict';

namespace Core {
    angular
        .module('core')
        .directive('sash', (): ng.IDirective => {

        return {
            scope: {
                ribbon: '=?',
                isFromOverlay: '=?'
            },
            restrict: 'E',
            link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => {
                scope.$watch('ribbon', function(value: any) {
                    // TODO - refactor, fixes attaching several child content elements
                    element.empty();
                    let ribbon = scope.isFromOverlay ?
                    scope.ribbon && scope.ribbon.hotel && scope.ribbon.hotel.OverlaysNew[0]
                    || (scope.ribbon && scope.ribbon.OverlaysNew[0] || scope.ribbon)
                    : scope.ribbon;

                    if (ribbon) {
                        ribbon = !scope.isFromOverlay ? ribbon && (ribbon.ribbon || ribbon)
                            && (ribbon.ribbon && ribbon.ribbon.ribbon || ribbon.ribbon) : ribbon; // Find ribbon object

                        const prefix = 'sc-c-sash--';   // Sash base style class
                        const styles = [
                            'sc-c-sash',
                            `${prefix}${ribbon && ribbon.ColourClass}`
                        ]; // Sash color class style

                        ribbon.EffectClasses.forEach((effect: string) => {
                            styles.push(`${prefix}${effect}`); // Sets effect class to sash
                        });

                        const styleClass = styles.join(' ');   // Join all styles into one
                        const contentClass = 'sc-c-sash__label';

                        let ribbonElement = angular.element(`<div>`).addClass(styleClass);
                        const ribbonContent = angular.element(`<div>`).addClass(contentClass);
                        const textLengthValidator = (text: string) => text && text.slice(0, 10);
                        const textSeparator = ribbon.Text.includes('|') ? '|' : ' ';
                        const textArray: string[] = ribbon.Text.toUpperCase()
                                                                .split(textSeparator)
                                                                .map(textLengthValidator);

                        const boldStrClass = 'star-rating sc-u-bold sc-c-sash__row row-gutter-y__zero';
                        const normalStrClass = 'star-rating sc-c-sash__row row-gutter-y__zero';
                        textArray.forEach((current: string, index: number) => {
                            const isBold = ((textArray.length - 1) === index && textArray.length > 2) || index === 0;
                            const label = angular.element(`<span>${current}</span>`)
                                .addClass(isBold ? boldStrClass : normalStrClass);
                            ribbonContent.append(label);
                        });

                        ribbonElement.append(ribbonContent);
                        element.append(ribbonElement);
                    }
                });
            }
        };

    });

}
